import React, { useContext } from 'react';

import { Collapse, List, ListItem, ListItemText } from '@material-ui/core';
import { ExpandLessRounded, ExpandMoreRounded } from '@material-ui/icons';

import { IEventRound } from '../../../../../store/admin/eventRounds/store';

import { useBoolean } from '../../../../common/Hooks/useBoolean.hook';
import { GlobalContext } from '../../../../../store';
import { initialEventTemplate } from '../../../../../store/admin/events/store';

interface IProps {
  round: IEventRound;
  index: number;
  clubId: number;
  eventId?: number;
  navigateTo: (destinationURL: string) => () => void;
}

export const EventWizardNavigatorMobileRoundItem = (props: IProps) => {
  const { index, clubId, eventId, round } = props;

  const { adminEvents } = useContext(GlobalContext);

  const [openRoundN, , toggleOpenRoundN] = useBoolean(false);

  const baseWizard = `/staff/club/${clubId}/event/${eventId}`;
  const baseRoundSection = `${baseWizard}/round/${round.id}`;

  const event = adminEvents[Number(eventId)] || initialEventTemplate;

  const subitemsMetadata = {
    round: [
      { section: `${baseRoundSection}/setup`, label: 'Setup' },
      round.order === 0 && event.allowTeams
        ? { section: `${baseRoundSection}/teams`, label: 'Teams' }
        : null,
      { section: `${baseRoundSection}/teesheet`, label: 'Tee Sheet' },
      { section: `${baseRoundSection}/contest`, label: 'Contest' },
      round.order === 0 && event.flights.length > 1
        ? { section: `${baseRoundSection}/flights`, label: 'Flights' }
        : null,
      { section: `${baseRoundSection}/launch`, label: 'Launch' },
      { section: `${baseRoundSection}/results`, label: 'Results' },
      { section: `${baseRoundSection}/awards`, label: 'Awards' },
      { section: `${baseRoundSection}/complete`, label: 'Complete' }
    ].filter(Boolean)
  };

  const navigateTo = (destinationURL: string) => () => {
    toggleOpenRoundN();
    props.navigateTo(destinationURL)();
  };

  return (
    <>
      <ListItem button={true} className={'mobile-menu-item'} onClick={toggleOpenRoundN}>
        {openRoundN ? <ExpandLessRounded /> : <ExpandMoreRounded />}
        <ListItemText primary={`Round ${index + 1}`} />
      </ListItem>
      <Collapse in={openRoundN} timeout="auto" unmountOnExit={true}>
        <List disablePadding={true} className={'mobile-menu-sublist'}>
          {subitemsMetadata.round.filter(Boolean).map(subitem =>
            subitem ? (
              <ListItem
                button={true}
                className="mobile-menu-subitem"
                onClick={navigateTo(`${subitem.section}`)}
                key={`subitem-round-${round.id}-${subitem.label}`}
              >
                <ListItemText className="mobile-menu-subitem-label" primary={subitem.label} />
              </ListItem>
            ) : (
              <></>
            )
          )}
        </List>
      </Collapse>
    </>
  );
};
